import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=d0100d36&scoped=true"
import script from "./ClientsList.vue?vue&type=script&lang=js"
export * from "./ClientsList.vue?vue&type=script&lang=js"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=d0100d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0100d36",
  null
  
)

export default component.exports